import React, { useState, useEffect } from 'react';
import LmsPackage from './LmsPackage';

/**
 * This component is used for displaying all LMS packages, each with different features and contents.
 */
const LmsPackages: React.FC = () => {
  const [currentIndex, setCurrentIndex] = useState(0);
  const [isSmallScreen, setIsSmallScreen] = useState(false);

  const packages = [
    {
      packageName: "Paket Starter",
      textColors: 'font-body text-secondary-100 text-sm my-2',
      packageContents: [
        {
          contents:
            ["Free Domain dan Hosting 1 Tahun",
            "Sedia Admin",
            "Free Konsultasi",
            "Free Desain Logo",
            "Free Akses Tutorial Selamanya"]
          }]},
    {
      packageName: "Paket Basic Enterprise",
      textColors: 'font-body text-secondary-100 text-sm my-2',
      packageContents: [
        {
          contents:
            ["Seluruh Isi Paket Starter",
            "Free Desain seluruh Kebutuhan Design (5 bagian design)",
            "Free Upload Data (peserta, materi, kelas, dll)",
            "Free Demonstrasi and Training",
            "Maintenance 1 Tahun"]
        }]},
    {
      packageName: "Paket Full Enterprise",
      textColors: 'font-body text-secondary-100 text-sm my-2 mr-2',
      packageContents: [
        {
          contents: [
            "Seluruh Isi Paket Basic",
            "Harga Kursus",
            "Pembuatan Grafik",
            "Turnitin Plagiarism",
            "Kebutuhan Kelompok",
            "Rating Mata Pelajaran",
            "Laporan Penilaian PDF",
            "Lab Pemrograman Coding",
            "Turnitin Plagiarism",
            "Integrasi Platform Meetings",
            "Dan Sesuai Custom Lainnya"]
        }]}
  ];

  useEffect(() => {
    const handleResize = () => {
      setIsSmallScreen(window.innerWidth < 768);
    };

    handleResize();

    window.addEventListener('resize', handleResize);
    return () => window.removeEventListener('resize', handleResize);
  }, []);

  const handlePrev = () => {
    setCurrentIndex((prev) => (prev === 0 ? 0 : prev - 1));
  };

  const handleNext = () => {
    setCurrentIndex((prev) => (prev === packages.length - 1 ? packages.length - 1 : prev + 1));
  };

  if (isSmallScreen) {
    return (
      <div className="w-full flex justify-center px-4 mt-6 md:mt-0 relative max-w-7xl mx-auto">
        <div className="w-full max-w-md mx-auto flex justify-center relative">
          <button
            onClick={handleNext}
            className={`absolute right-0 top-1/2 -translate-y-1/2 z-10 w-10 h-10 shadow p-2 rounded-full flex items-center justify-center ${currentIndex === packages.length - 1 ? 'hidden' : ''}`}
          >
            <img
              src="/img/lms/right-arrow.png"
              alt="Right"
              className="absolute inset-0 m-auto"
            />
          </button>
          <LmsPackage
            packageName={packages[currentIndex]?.packageName ?? ''}
            textColors={packages[currentIndex]?.textColors ?? ''}
            packageContents={packages[currentIndex]?.packageContents ?? []}
            packageIndex={currentIndex}
          />
          <button
            onClick={handlePrev}
            className={`absolute left-0 top-1/2 -translate-y-1/2 z-10 w-10 h-10 shadow p-2 rounded-full flex items-center justify-center ${currentIndex === 0 ? 'hidden' : ''}`}
          >
            <img
              src="/img/lms/left-arrow.png"
              alt="Left"
              className="absolute inset-0 m-auto"
            />
          </button>
        </div>
      </div>
    );
  }

  return (
    <div className="w-full flex justify-center px-4 mt-6 md:mt-0">
      <div className='grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-10 max-w-7xl'>
        {packages.map((pkg, index) => (
          <LmsPackage
            key={index}
            packageName={pkg.packageName}
            textColors={pkg.textColors}
            packageContents={pkg.packageContents}
            packageIndex={index}
          />
        ))}
      </div>
    </div>
  );
}

export default LmsPackages;